<template>
  <div class="app-container">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>删除产品广告 — 采集/删除日志</span>
        <el-button type="text" @click="goBack">返回广告账户</el-button>
      </div>
      <div class="filter-wrap">
        <div class="searchContainer">
          <label class="inputLabel">广告主 id：</label>
          <el-input
            v-model.trim="query.account_id"
            clearable
            placeholder="精确"
            class="filter-input"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">广告主名称：</label>
          <el-input
            v-model.trim="query.account_name"
            clearable
            placeholder="模糊"
            class="filter-input"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">广告组 id：</label>
          <el-input
            v-model.trim="query.adgroup_id"
            clearable
            placeholder="精确"
            class="filter-input"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">广告组名称：</label>
          <el-input
            v-model.trim="query.adgroup_name"
            clearable
            placeholder="模糊"
            class="filter-input"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">营销资产 id：</label>
          <el-input
            v-model.trim="query.marketing_asset_id"
            clearable
            placeholder="精确"
            class="filter-input"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">产品名：</label>
          <el-input
            v-model.trim="query.marketing_asset_name"
            clearable
            placeholder="模糊"
            class="filter-input"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">采集批次：</label>
          <el-input
            v-model.trim="query.collect_batch_id"
            clearable
            placeholder="UUID 精确"
            class="filter-input wide"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">状态：</label>
          <el-select
            v-model="query.status"
            clearable
            placeholder="全部"
            class="filter-select"
          >
            <el-option label="未处理" :value="0" />
            <el-option label="删除成功" :value="1" />
            <el-option label="失败" :value="2" />
          </el-select>
        </div>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >查询</el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <div class="toolbar-batch">
        <el-button
          type="warning"
          icon="el-icon-refresh"
          @click="openSyncAssetDialog"
        >同步产品广告</el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="!multipleSelection.length"
          :loading="delLoading"
          @click="handleBatchDelete"
        >删除广告</el-button>
        <span v-if="multipleSelection.length" class="toolbar-hint">已选 {{ multipleSelection.length }} 条</span>
      </div>

      <el-table
        ref="logTable"
        v-loading="loading"
        :data="tableData"
        border
        row-key="id"
        style="width: 100%; margin-top: 12px"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="48"
          align="center"
        />
        <el-table-column prop="id" label="id" width="72" align="center" />
        <el-table-column
          prop="collect_batch_id"
          label="采集批次"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column prop="account_id" label="广告主 id" width="100" align="center" />
        <el-table-column
          prop="account_name"
          label="广告主名称"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column prop="adgroup_id" label="广告组 id" width="100" align="center" />
        <el-table-column
          prop="adgroup_name"
          label="广告组名称"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column prop="marketing_asset_id" label="营销资产 id" width="110" align="center" />
        <el-table-column
          prop="marketing_asset_name"
          label="产品名"
          min-width="100"
          show-overflow-tooltip
        />
        <el-table-column prop="admin_id" label="管理员 id" width="90" align="center" />
        <el-table-column prop="status_str" label="状态" width="88" align="center" />
        <el-table-column
          prop="fail_reason"
          label="失败原因"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column prop="created_at_text" label="创建时间" width="160" align="center" />
      </el-table>

      <PaginationRight
        :total="total"
        :current-page="query.page"
        :page-size="query.page_size"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />

      <el-dialog
        title="同步账户资产"
        :close-on-click-modal="false"
        :visible.sync="syncAssetDialogVisible"
        width="700px"
        append-to-body
        @closed="onSyncAssetDialogClosed"
      >
        <accoutIdDialog ref="syncAccountDialog" @submit="submitSyncAsset" />
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  delAdsByMarketingAssetNameLog,
  delAdsByProductLogIds
} from '@/api/report/accountManagement'
import { delAdsByMarketingAssetName } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import accoutIdDialog from './CopyAdqAdDialog/accoutIdDialog.vue'

function emptyQuery() {
  return {
    account_id: '',
    account_name: '',
    adgroup_id: '',
    adgroup_name: '',
    marketing_asset_id: '',
    marketing_asset_name: '',
    collect_batch_id: '',
    status: undefined,
    page: 1,
    page_size: 10
  }
}

export default {
  name: 'DelAdsByProductLog',
  components: { PaginationRight, accoutIdDialog },
  data() {
    return {
      loading: false,
      delLoading: false,
      syncAssetDialogVisible: false,
      multipleSelection: [],
      tableData: [],
      total: 0,
      query: emptyQuery()
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/tencentAD/accountAD/index' })
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },
    clearTableSelection() {
      this.multipleSelection = []
      if (this.$refs.logTable) {
        this.$refs.logTable.clearSelection()
      }
    },
    openSyncAssetDialog() {
      this.syncAssetDialogVisible = true
      this.$nextTick(() => {
        const dlg = this.$refs.syncAccountDialog
        if (!dlg) return
        const uniq = []
        const seen = new Set()
        this.multipleSelection.forEach((r) => {
          if (r.account_id == null || r.account_id === '') return
          const aid = Number(r.account_id)
          if (seen.has(aid)) return
          seen.add(aid)
          uniq.push({
            account_id: aid,
            account_name: r.account_name || ''
          })
        })
        dlg.merchant_ids = uniq
      })
    },
    onSyncAssetDialogClosed() {
      const dlg = this.$refs.syncAccountDialog
      if (dlg) {
        dlg.merchant_ids = []
        if (dlg.ruleForm) {
          dlg.ruleForm.account_ids = ''
        }
      }
    },
    async submitSyncAsset(obj, done) {
      try {
        await delAdsByMarketingAssetName(obj)
        this.$message.success('创建成功')
        this.syncAssetDialogVisible = false
        if (typeof done === 'function') done()
        this.loadList()
      } catch (e) {
        /* request 拦截器已提示 */
      }
    },
    handleBatchDelete() {
      if (!this.multipleSelection.length) return
      const ids = this.multipleSelection.map((r) => r.id)
      this.$confirm(
        `确定对选中的 ${ids.length} 条日志执行删除广告（将调用腾讯删除接口）？`,
        '提示',
        { type: 'warning' }
      )
        .then(() => {
          this.delLoading = true
          return delAdsByProductLogIds({ ids })
        })
        .then((res) => {
          if (!res || res.code !== 0) {
            this.$message.error((res && res.message) || '操作失败')
            return
          }
          this.$message.success(res.message || '处理完成')
          const d = res.data || {}
          const parts = []
          if (d.success_ids && d.success_ids.length) {
            parts.push(`成功 ${d.success_ids.length} 条`)
          }
          if (d.failed && d.failed.length) {
            parts.push(`失败 ${d.failed.length} 条`)
          }
          if (d.skipped && d.skipped.length) {
            parts.push(`跳过 ${d.skipped.length} 条`)
          }
          if (parts.length) {
            this.$message.info(parts.join('，'))
          }
          this.clearTableSelection()
          this.loadList()
        })
        .catch((err) => {
          if (err !== 'cancel') {
            /* request 已提示 */
          }
        })
        .finally(() => {
          this.delLoading = false
        })
    },
    buildParams() {
      const q = this.query
      const p = {
        page: q.page,
        page_size: q.page_size
      }
      const num = (v) => {
        if (v === '' || v === null || v === undefined) return null
        const n = parseInt(String(v).trim(), 10)
        return Number.isFinite(n) ? n : null
      }
      const str = (v) => {
        if (v === '' || v === null || v === undefined) return null
        return String(v).trim()
      }

      const aid = num(q.account_id)
      if (aid !== null) p.account_id = aid
      const an = str(q.account_name)
      if (an) p.account_name = an
      const gid = num(q.adgroup_id)
      if (gid !== null) p.adgroup_id = gid
      const gn = str(q.adgroup_name)
      if (gn) p.adgroup_name = gn
      const mid = num(q.marketing_asset_id)
      if (mid !== null) p.marketing_asset_id = mid
      const mn = str(q.marketing_asset_name)
      if (mn) p.marketing_asset_name = mn
      const bid = str(q.collect_batch_id)
      if (bid) p.collect_batch_id = bid
      if (q.status === 0 || q.status === 1 || q.status === 2) {
        p.status = q.status
      }
      return p
    },
    loadList() {
      this.loading = true
      delAdsByMarketingAssetNameLog(this.buildParams())
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.tableData = res.data.list || []
            this.total = res.data.total || 0
          } else {
            this.tableData = []
            this.total = 0
          }
          this.$nextTick(() => this.clearTableSelection())
        })
        .catch(() => {
          this.tableData = []
          this.total = 0
          this.$nextTick(() => this.clearTableSelection())
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.query.page = 1
      this.loadList()
    },
    handleReset() {
      const { page_size } = this.query
      this.query = { ...emptyQuery(), page: 1, page_size }
      this.loadList()
    },
    fetchPageSize(val) {
      this.query.page_size = val
      this.query.page = 1
      this.loadList()
    },
    fetchCurrentPage(val) {
      this.query.page = val
      this.loadList()
    }
  }
}
</script>

<style lang="less" scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filter-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 8px;
}
.searchContainer {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  margin-right: 12px;
  font-size: 14px;
  .inputLabel {
    flex-shrink: 0;
    width: 100px;
    font-weight: normal;
    margin: 0;
  }
}
.filter-input {
  width: 160px;
  &.wide {
    width: 280px;
  }
}
.filter-select {
  width: 140px;
}
.toolbar-batch {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.toolbar-hint {
  font-size: 13px;
  color: #909399;
}
</style>
